
import { intl } from "LocaleWrapper";
import { Table, QuickFilterTypes } from "@cofano/cck";
import { TableId, useFrontendTable } from "components/table";
import { NstrGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

interface ProductsNstrTableProps {
	content: NstrGoodFragment[];
	contentLoading: boolean;
	onRowClick: (row: NstrGoodFragment) => void;
}

const ProductsNstrTable = ({ content, contentLoading, onRowClick }: ProductsNstrTableProps) => {

	const { tableProps } = useFrontendTable({
		id: TableId.ProductsNstr,
		content: content || [],
		onCustomFilter: (property) => {
			if (property === "nstrCode") {
				return (field, value) => field.toString().includes(value);
			}
		},
	});

	return (
		<Table
			{...tableProps}
			contentLoading={contentLoading}
			onRowClick={row => onRowClick(row as NstrGoodFragment)}
			columns={[ {
				id: "nstrCode",
				title: intl.formatMessage({ id: "PRODUCTS_NSTR_CODE" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 200,
			}, {
				id: "cargoGroup",
				title: intl.formatMessage({ id: "PRODUCT_NSTR_CARGO_GROUP" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 150,
			}, {
				id: "dischargingInWaterway",
				title: intl.formatMessage({ id: "PRODUCT_NSTR_DISCHARGE_IN_WATERWAY" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 200,
			}, {
				id: "dischargingInSewers",
				title: intl.formatMessage({ id: "PRODUCT_NSTR_DISCHARGE_IN_SEWERS" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 200,
			}, {
				id: "specialTreatment",
				title: intl.formatMessage({ id: "PRODUCT_NSTR_SPECIAL_TREATMENT" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 200,
			}, {
				id: "remark",
				title: intl.formatMessage({ id: "PRODUCT_NSTR_REMARK" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
				width: 150,
			} ]} />
	);
};

export default ProductsNstrTable;
